module.exports = __webpack_public_path__ + "img/arrcs.c330212.png";